import { render } from "./News51.vue?vue&type=template&id=1002e9f4"
import script from "./News51.vue?vue&type=script&lang=js"
export * from "./News51.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__